export default "__VITE_ASSET__2876d47e__"